// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__9Ixn4","base":"Dashboard_base__1x6Iw"};